import { Component, Inject, Input, OnInit, Optional, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { AccountType, IAccountInformation } from '~shared/models';
import { MetroxTrackingLabels } from '~app/modules/generic/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { HeaderLogoUtil } from '~app/modules/generic/utils/header-logo.util';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { MediaService } from '~shared/services/media.service';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { catchError, filter, map, startWith } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthorizationStateType, FF_ACCOUNT_FLYOUT } from '~app/modules/authorization/constants/authorization.constant';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { ACCOUNT_TYPE_KEY } from '~app/core/modules/identity/constants/identity.constant';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { IS_COMPANION } from '~app/app.module';

@Component({
  selector: 'app-generic-header-topline',
  templateUrl: './header-topline.component.html',
  styleUrls: ['./header-topline.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderToplineComponent implements OnInit {
  headerLogoLink: string;
  @Input() user: IAccountInformation;
  @Input() isSidenavVersion = false;
  isDesktop = false;
  isTablet = false;
  headerLogoName: string;
  isGtTablet: Observable<boolean>;
  byPassfeatureFlag = false;
  showHeaderTopline = true;
  authState$ = this.authIdamStateService.state$;
  accountType$ = this.accountInfoService.accountType$;
  accountType = AccountType;
  LoggedOutState = AuthorizationStateType.LoggedOut;

  constructor(
    private applicationEventService: ApplicationEventService,
    private mediaService: MediaService,
    private featureFlagService: ActiveFeaturesConfigcatService,
    private authIdamStateService: AuthorizationIdamStateService,
    private accountInfoService: AccountInfoService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
    @Optional() @Inject(IS_COMPANION) public isCompanion
  ) {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    this.headerLogoLink = HeaderLogoUtil.getHeaderLogoLink(market);
    this.headerLogoName = HeaderLogoUtil.getHeaderLogoName(market);
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter<NavigationEnd>((event: any) => event instanceof NavigationEnd),
          startWith(this.router)
        )
        .subscribe((event) => {
          this.showHeaderTopline = !UrlUtils.getIsEmployeeRestrictedView(event.url);
          this.headerLogoLink = HeaderLogoUtil.getHeaderLogoLink(
            market,
            (localStorage.getItem(ACCOUNT_TYPE_KEY) as AccountType) ?? AccountType.CUSTOMER
          );
        });
    }
  }
  ngOnInit(): void {
    this.featureFlagService
      .isFeatureEnabledAndReadyV2(FF_ACCOUNT_FLYOUT)
      .pipe(catchError(() => of(false)))
      .subscribe((isEnabled) => {
        if (isEnabled) {
          this.checkResolutionDevice();
        } else {
          this.byPassfeatureFlag = true;
        }
      });
  }

  onLogoClick() {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(ApplicationNavigationEventType.GlobalHeaderClick, MetroxTrackingLabels.Logo)
    );
  }
  checkResolutionDevice(): void {
    this.isGtTablet = this.mediaService.mediaAliases$.pipe(
      map(() => this.mediaService.isAliasActive(MEDIA_ALISES.gtTablet))
    );
  }
}
